module.exports = __webpack_public_path__ + "c5c840572a7a39571d755bd7b6a5c0d3.fbx";